<template>
    <article v-if="item !== null" class="icon-bullet-list" :class="getModuleThemeClass()">
        <div class="icon-bullet-list__stamp">
            <div v-if="item.StampPreline" class="icon-bullet-list__stamp-preline">{{ item.StampPreline }}</div>
            <div v-if="item.StampHeadline" class="icon-bullet-list__stamp-headline">{{ item.StampHeadline }}</div>
            <div v-if="item.StampPostline" class="icon-bullet-list__stamp-postline">{{ item.StampPostline }}</div>
        </div>
        <ul v-if="item.Items !== null && item.Items.length > 0" class="icon-bullet-list__list">
            <li v-for="bullet in item.Items" :key="bullet.id" class="icon-bullet-list__item">
                <img :src="bullet.Icon && bullet.Icon.SelectedOptions && bullet.Icon.SelectedOptions[0] ? bullet.Icon.SelectedOptions[0].Value : ''" :alt="bullet.Icon && bullet.Icon.SelectedOptions && bullet.Icon.SelectedOptions[0] ? bullet.Icon.SelectedOptions[0].Name : ''" />
                <p class="icon-bullet-list__text">{{ bullet.Text }}</p>
            </li>
        </ul>
    </article>
</template>
<script>
import { useItem } from '../composables/item';
const { getThemeClass } = useItem();

export default {
    name: 'IconBulletList',
    props: {
        item: {
            type: Object,
            default: null
        }
    },
    methods: {
        getModuleThemeClass() {
            return getThemeClass(this.item);
        }
    }
};
</script>
